import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qhsepolicy',
  templateUrl: './qhsepolicy.component.html',
  styleUrls: ['./qhsepolicy.component.css']
})
export class QhsepolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
